export default __webpack_public_path__ + "static/logo_3x2-82b3ec881f6529d80c4cf255d3335476.png";